import LiveSessionScreen from 'src/consumer/components/LiveSessionPage'
import { InformationContextProvider } from 'src/consumer/context/InformationContext'
import { SetupContextProvider } from 'src/consumer/context/SetupContext'

/**
 * Renders the consumer LiveSessionScreen under the mentor-scoped /mentor-home/l/* route.
 *
 * The session expects the two consumer-layout providers that ConsumerLayout wraps /l/* in —
 * SetupContext and InformationContext — which are NOT app-level. Under MentorLayout they'd be
 * absent, so SecuredLiveSessionPage's `const { setupData } = useContext(SetupContext)` would
 * destructure `undefined` and the page renders blank. We provide both here (mirroring
 * ConsumerLayout) so the session has its full expected environment. Both are safe under
 * MentorLayout: SetupContextProvider is Redux-backed and skips its fetch on /mentor-home/l/
 * (see SetupContext.jsx), and InformationContextProvider is pure local state.
 */
export default function MentorLiveSessionRoute(props) {
  return (
    <SetupContextProvider>
      <InformationContextProvider>
        <LiveSessionScreen {...props} />
      </InformationContextProvider>
    </SetupContextProvider>
  )
}
